/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_Th7Inputs */

const en_mk_cmp_multica_th7 = /** @type {(inputs: Mk_Cmp_Multica_Th7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — Docker Compose or Helm, free, full control.`)
};

const id_mk_cmp_multica_th7 = /** @type {(inputs: Mk_Cmp_Multica_Th7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya — Docker Compose atau Helm, gratis, kendali penuh.`)
};

/**
* | output |
* | --- |
* | "Yes — Docker Compose or Helm, free, full control." |
*
* @param {Mk_Cmp_Multica_Th7Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_th7 = /** @type {((inputs?: Mk_Cmp_Multica_Th7Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_Th7Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_th7(inputs)
	return en_mk_cmp_multica_th7(inputs)
});